import React from 'react'
import styles from "./landingPage.module.css"

const LandingPageCompNew = () => {
  return (
    <div className={styles.landingPageDialog}>
      <h1 className={styles.header}>spotistats</h1>
      <p className={styles.description}>With this service you can see your top tracks on Spotify and create weekly updating playlists with these tracks.</p>
    </div>
  )
}

export default LandingPageCompNew

